module.exports = __webpack_public_path__ + "img/img2.e8ed4610.svg";